import {useEffect} from 'react';

export const lifecycle = {
  componentDidMount: async (state: any, props: any) => {
    const {setLoading} = state;
    const {actions, sales} = props;

    const _useEffect = async () => {
      try {
        if (sales.pages.active.length === 0 || window.isInitial) {
          setLoading(true);

          await actions.sales.getPagination(
            sales.current,
            sales.searchWords,
            sales.sortState,
            true
          );

          setLoading(false);

          window.isInitial = false;
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };

    useEffect(() => {
      _useEffect();
    }, []);
  },
};
